import { Icon, Typography, Checkbox, Menu, CircularProgress, Alert } from "@ann/web-components";
import { ItemWrapper, ItemLeft, MenuIconWrapper } from "./Item.styled";
import { useState, useEffect, useRef, useCallback } from "react";
import { ModalBase } from "../../../../components/Modal";
import { useStore } from "../../../../../../../hooks";

const DocumentItem = ({ uuid, name, selectMode, onSelect, selectedItems, onRemoveAction, onDeleteSuccess, setShowSlideoutDocumentDetail, setSelectedDocument }) => {
    const [showMenu, setShowMenu] = useState(false);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [alert, setAlert] = useState(null);
    const menuRef = useRef(null);
    const { documentStore, playgroundConfigStore } = useStore();

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (menuRef.current && !menuRef.current.contains(event.target)) {
                setShowMenu(false);
            }
        };
        if (showMenu) {
            document.addEventListener("mousedown", handleClickOutside);
        } else {
            document.removeEventListener("mousedown", handleClickOutside);
        }

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [showMenu]);


    const handleMenuClick = () => {
        setShowMenu(!showMenu);
    }

    const handleDelete = useCallback(async () => {
        try {
            const agentUuid = playgroundConfigStore.agentStore.uuid;
            const tenantId = "58145bef-4f71-468a-bded-1823d2a08f58";

            if (!agentUuid) {
                throw new Error('Agent UUID not found');
            }

            const result = await documentStore.deleteDocument(uuid, agentUuid, tenantId);

            if (result.success) {
                setAlert({
                    title: "Success",
                    message: `Document "${name}" deleted successfully`,
                    severity: "success"
                });

                if (onDeleteSuccess) {
                    onDeleteSuccess(uuid);
                }
            } else {
                throw new Error(result.error || 'Failed to delete document');
            }
        } catch (error) {
            const errorMessage = error.response?.data?.message || error.message || 'Error deleting document';
            setAlert({
                title: "Error",
                message: errorMessage,
                severity: "error"
            });
        } finally {
            setShowDeleteModal(false);
        }
    }, [uuid, name, documentStore, playgroundConfigStore, onDeleteSuccess]);

    const handleDeleteClick = () => {
        if (onRemoveAction) {
            onRemoveAction();
        }
        setShowDeleteModal(true);
        setShowMenu(false);
    }

    const handleViewDetails = () => {
        setSelectedDocument({
            uuid,
            title: name
        });
        setShowSlideoutDocumentDetail(true);
        setShowMenu(false);
    }

    const handleCloseAlert = useCallback(() => {
        setAlert(null);
    }, []);

    return (
        <>
            {alert && (
                <Alert
                    title={alert.message}
                    severity={alert.severity}
                    onClose={handleCloseAlert}
                    maxWidth="400px"
                    closable={true}
                    autoClose={true}
                    autoCloseDelay={3000}
                />
            )}
            <ItemWrapper >
                <ItemLeft>
                    {selectMode && (
                        <Checkbox
                            onChange={() => onSelect(uuid)}
                            size="medium"
                            checked={selectedItems.includes(uuid)}
                        />
                    )}
                    <Icon name="description" size="medium" />
                    <Typography category="subtitle" size="small" weight="bold" color="subtitle">
                        {name}
                    </Typography>
                </ItemLeft>
                <MenuIconWrapper onClick={handleMenuClick}>
                    <Icon name="dotsMenu" />
                </MenuIconWrapper>
                {showMenu && (<Menu className="add-menu" width="260px">
                    <div ref={menuRef}>
                        <Menu.Item id="Delete" title='Delete' onClick={handleDeleteClick} />
                        <Menu.Item id="View-details " title='View details' onClick={handleViewDetails} />
                    </div>
                </Menu>)}
            </ItemWrapper>
            {showDeleteModal && (
                <ModalBase
                    isOpen={showDeleteModal}
                    onClose={() => setShowDeleteModal(false)}
                    onClick={handleDelete}
                    title={`Are you sure you want to delete this file?`}
                    description={"This action will unassign the file from your agent's knowledge base and soft delete it."}
                    buttonTitle={documentStore.isDeletingDocument ? "Deleting..." : "Delete"}
                    disabled={documentStore.isDeletingDocument}
                    modalWidth="571px" />
            )}
        </>
    )
}

export default DocumentItem;